import React, { useState, useEffect } from 'react';
import { TableContainer, Table, TableBody, TableRow, TableCell, Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import appRoute from '../../../Route/appRoutes';
import http from '../../../api';
import { getComparator, stableSort } from '../../../component/table/function';
import { NotificationManager } from 'react-notifications';
import EnhancedTableHead from '../../../component/table/EnhancedTableHead';

const List = () => {
	const closeSidebar = useSelector(state => state.reducer.closeSidebar);
	const history = useHistory();

	const [order, setOrder] = useState('desc');
	const [orderBy, setOrderBy] = useState('message_type_name');
	const [messageTypes, setMessageTypes] = useState([]);
	const [apiLoading, setApiLoading] = useState(false);

	useEffect(() => {
		getMessageTypes()
	}, [])

	const getMessageTypes = () => {
		// let accessToken = JSON.parse(localStorage.userdata).access_token;
		setApiLoading(true);
		const params = {
			"SearchText": "",
			"PageSize": 20,
			"CurrentPage": 1,
			"SortCol": orderBy,
			"SortOrder": order,
			"ActivationStatus": "",
			"Organization": "",
			"Integration": ""
		}

		http.post(`/api/v1/Message/MessageType/GET`, params)
			.then((res) => {
				setMessageTypes(res?.Value ?? []);
				setApiLoading(false);
			}).catch((error) => {
				console.log(error);
				NotificationManager.error('Something went wrong', '', 3000);
				setApiLoading(false);
			})
	}

	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	if (apiLoading) {
		return null;
	}

	const headCells = [
		{ id: 'message_type_name', label: 'Name' },
		{ id: 'filename_pattern_01', label: 'Filename Pattern 1' },
		{ id: 'contents_pattern_01', label: 'Contents Pattern 1' },
		{ id: 'contents_pattern_02', label: 'Contents Pattern 2' },
	];

	return (
		<div className={`mainSection integrationComponent ${closeSidebar ? 'maxMainSection' : 'minMainSection'}`}  >
			<div className='mainSectionHeading withAddnew'>
				<span>Message Type</span>
				<Button variant='contained' onClick={() => {
					history.push(appRoute.MessageTypeCreate);
				}}>Add Message Type</Button>
			</div>
			<div className='container-fluid message-type-container'>
				<TableContainer>
					<Table stickyHeader>
						<EnhancedTableHead
							headCells={headCells}
							order={order}
							orderBy={orderBy}
							onRequestSort={handleRequestSort}
							action={false} />
						<TableBody>
							{
								messageTypes.length ?
									stableSort(messageTypes, getComparator(order, orderBy))
										.map((row, index) => {
											return (
												<TableRow hover key={index}>
													<TableCell align='center'>{index + 1}</TableCell>
													<TableCell title={row.message_type_name}>{row.message_type_name}</TableCell>
													<TableCell title={row.filename_pattern_01}>{row.filename_pattern_01}</TableCell>
													<TableCell title={row.contents_pattern_01}>{row.contents_pattern_01}</TableCell>
													<TableCell title={row.contents_pattern_02}>{row.contents_pattern_02}</TableCell>
												</TableRow>
											);
										})
									:
									<TableRow>
										<TableCell colSpan={headCells.length + 1} align={'center'}>No message types found</TableCell>
									</TableRow>
							}
						</TableBody>
					</Table>
				</TableContainer>
			</div>
		</div>
	)
}


export default List;